import React, { useState, useCallback } from 'react';
import './SignatureListToolbar.css';

// Simple debounce utility
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function SignatureListToolbar({
    searchTerm,
    onSearchChange,
    sortBy,
    onSortChange,
    selectedCount,
    totalCount,
    onSelectAll,
    onBulkDelete,
    viewMode,
    onViewModeChange
}) {
    const [localSearchTerm, setLocalSearchTerm] = useState(searchTerm);

    // Debounced search
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedSearch = useCallback(
        debounce((term) => {
            onSearchChange(term);
        }, 300),
        []
    );

    const handleSearchInput = (e) => {
        const value = e.target.value;
        setLocalSearchTerm(value);
        debouncedSearch(value);
    };

    return (
        <div className="signature-list-toolbar">
            <div className="toolbar-row">
                <div className="search-box">
                    <svg
                        className="search-icon"
                        width="20"
                        height="20"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                    </svg>
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Rechercher une signature..."
                        value={localSearchTerm}
                        onChange={handleSearchInput}
                    />
                </div>

                <div className="toolbar-controls">
                    <div className="sort-dropdown">
                        <label htmlFor="sort-select">Trier par:</label>
                        <select
                            id="sort-select"
                            value={sortBy}
                            onChange={(e) => onSortChange(e.target.value)}
                        >
                            <option value="date">Date (plus récent)</option>
                            <option value="name">Nom (A-Z)</option>
                            <option value="default">Défaut</option>
                        </select>
                    </div>

                    <div className="view-mode-toggle">
                        <button
                            className={`view-mode-btn ${viewMode === 'grid' ? 'active' : ''}`}
                            onClick={() => onViewModeChange('grid')}
                            title="Vue en grille"
                        >
                            <svg
                                width="20"
                                height="20"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                                />
                            </svg>
                        </button>
                        <button
                            className={`view-mode-btn ${viewMode === 'table' ? 'active' : ''}`}
                            onClick={() => onViewModeChange('table')}
                            title="Vue en tableau"
                        >
                            <svg
                                width="20"
                                height="20"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <div className="toolbar-row">
                <div className="selection-controls">
                    <label className="checkbox-label">
                        <input
                            type="checkbox"
                            checked={selectedCount > 0 && selectedCount === totalCount}
                            onChange={onSelectAll}
                        />
                        <span>
                            Tout sélectionner ({selectedCount}/{totalCount})
                        </span>
                    </label>
                </div>

                {selectedCount > 0 && (
                    <button
                        className="btn-bulk-delete"
                        onClick={onBulkDelete}
                    >
                        <svg
                            width="16"
                            height="16"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                            />
                        </svg>
                        Supprimer ({selectedCount})
                    </button>
                )}
            </div>
        </div>
    );
}

export default SignatureListToolbar;
